<script setup lang="ts">
import { QSkeleton } from 'quasar'
import { computed } from 'vue'
import { PSkeletonType } from './types'

type Props = {
  type?: null | PSkeletonType
  height?: null | string
  width?: null | string
}

const props = withDefaults(defineProps<Props>(), {
  type: PSkeletonType.CUSTOM,
  height: null,
  width: null,
})

const qHeight = computed<null | string>(() => {
  switch (props.type) {
    case PSkeletonType.CIRCLE: {
      return props.height || '32px'
    }
    case PSkeletonType.INPUT_FIELD: {
      return props.height || '40px'
    }
  }

  return props.height
})

const qWidth = computed<null | string>(() => {
  switch (props.type) {
    case PSkeletonType.CIRCLE: {
      return props.height || '32px'
    }
  }

  return props.width
})

const qType = computed<null | 'circle'>(() => {
  switch (props.type) {
    case PSkeletonType.CIRCLE: {
      return 'circle'
    }
  }

  return null
})
</script>

<template>
  <div>
    <q-skeleton
      :type="qType ?? undefined"
      :width="qWidth ?? undefined"
      :height="qHeight ?? undefined"
    />
  </div>
</template>
